import { bl_sfa_sales_lead_ext_RowClass } from "../../../dbschema/bl_sfa_sales_lead_ext.model";
import { BaseContainerModel } from "../../base-container.model";

export class SfaSalesLeadExtContainerModel extends BaseContainerModel {
    bl_sfa_sales_lead_ext: bl_sfa_sales_lead_ext_RowClass = new bl_sfa_sales_lead_ext_RowClass()
}